import { useEffect } from 'react';

const Init = ({ setState }) => {
  useEffect(() => {
    setState('AUTHENTICATING');
  }, [setState]);
  return <div>INIT</div>;
};
export default Init;
